import { onMessage } from "firebase/messaging";
import axios from "axios";
import { messaging, requestForToken } from "./firebase";
import { createRoot } from "react-dom/client";
import NotificationManager from "../Component/Notification/NotificationManager";
import React from "react";

let notificationContainer = null;
let notificationRoot = null;
let notifications = [];

const closeNotificationById = (id) => {
  notifications = notifications.filter((n) => n.id !== id);
  renderNotifications();
};

const renderNotifications = () => {
  if (!notificationContainer) {
    notificationContainer = document.createElement('div');
    document.body.appendChild(notificationContainer);
    notificationRoot = createRoot(notificationContainer);
  }

  notificationRoot.render(
    <NotificationManager
      notifications={notifications}
      onClose={closeNotificationById}
    />
  );
};

const showNotificationPopup = (title, body, image, deepLink) => {
  const id = Date.now() + Math.random();
  const notification = {
    id,
    title,
    body,
    image,
    deepLink: deepLink || null,
  };

  notifications.push(notification);
  renderNotifications();

  // Auto-close after 10 seconds
  setTimeout(() => {
    closeNotificationById(id);
  }, 10000);

  // Notify app to show red dot on bell icon
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("notification-received"));
  }
};

export const initializeNotifications = () => {
  if (!messaging) {
    console.warn("⚠️ Firebase messaging is not initialized. Skipping notification listener registration.");
    renderNotifications();
    return;
  }

  // Handle foreground notifications
  onMessage(messaging, (payload) => {
    console.log(payload);
    const deepLink = payload.data?.deepLink || payload.data?.url || payload.data?.link || "";
    showNotificationPopup(
      payload.notification?.title || "",
      payload.notification?.body || "",
      payload.notification?.image,
      deepLink
    );
  });

  // Register service worker
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(() => console.log("✅ Firebase messaging service worker registered"))
      .catch((err) => console.error("❌ Service worker registration failed:", err));
  }

  // Initial render
  renderNotifications();
};

export const registerFCMToken = async (endpoint) => {
  const token = await requestForToken();
  if (token) {
    await axios.patch(endpoint, { token });
    localStorage.setItem("admin_fcm_token", token);
    console.log("✅ FCM token saved");
  }
};

export const requestNotificationPermission = async (endpoint) => {
  if (Notification.permission === "default") {
    const result = await Notification.requestPermission();
    
    if (result === "granted") {
      console.log("✅ Notifications allowed");
      await registerFCMToken(endpoint);
    } else {
      console.warn("❌ Notifications blocked");
    }
  } else if (Notification.permission === "granted") {
    await registerFCMToken(endpoint);
  }
};
